module.exports = __webpack_public_path__ + "img/bg-4@2x.9cc98274.jpg";